type TErrors = {
  name?: string
}

export const validate = (values: { name: string }): TErrors => {
  const errors: TErrors = {}

  if (!values.name) errors.name = "Required"
  else if (!/^[A-Za-z0-9_-]{1,65}$/.test(values.name)) {
    errors.name =
      "Invalid value. The name must contain only A-Za-z_-. and max 65 symbols"
  }

  return errors
}
